import { Small } from "@fronterahealth/frontera-ui-components";
import { Button } from "@fronterahealth/frontera-ui-components/ui/button";

import { useCanRequestReview } from "@components/ReportReview/hooks/useCanManageReview";
import { useReviewRequest } from "@components/ReportReview/hooks/useReviewRequest";
import { Reviewer, latestSendBack } from "@components/ReportReview/reviewers";

/** The note the reviewer sent with their latest send-back, and the way to ask them to look again. */
export const ToFixNote: React.FC<{ reviewer: Reviewer }> = ({ reviewer }) => {
  const { request, isPending } = useReviewRequest();
  const canRequestReview = useCanRequestReview();
  const user = reviewer.reviewer;
  if (!user) return null;

  const note = latestSendBack(reviewer)?.note.trim();

  return (
    <>
      {note && (
        <Small data-testid="to-fix-note" className="block whitespace-pre-wrap">
          {note}
        </Small>
      )}
      <Button
        size="sm"
        data-dd-action-name="to-fix ask to look again"
        disabled={!canRequestReview || isPending}
        onClick={() => request([{ userId: user.id, type: reviewer.type }])}
      >
        Ask {user.firstName} to look again
      </Button>
    </>
  );
};
